module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Volume-down-b0eafe5d70d9dbfce97b1871a48829e5.svg";